import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border-radius: 10px;
`

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 18px;

`

export const TextArea = styled.textarea`
  width: 100%;
  height: 150px;
  overflow: hidden;
  padding: 10px 12px;
  resize: none;
  outline: none;
  border: 2px solid rgba(98, 147, 97, 0.15);
  border-radius: 6px;
  font-size: 14px;
`
